import {
  Button,
  Icon,
  Menu,
  MenuItem,
  MenuPopup,
  MenuSeparator,
  MenuTrigger,
} from "@salestrak/ui";
import type { Omittable } from "@salestrak/ui";

type WebhookActionsMenuProps = Omittable<{
  archived: boolean;
  onOpenChange?: (open: boolean) => void;
  onEdit: () => void;
  onToggleArchived: () => void;
  onDelete: () => void;
}>;

export function WebhookActionsMenu({
  archived,
  onOpenChange,
  onEdit,
  onToggleArchived,
  onDelete,
}: WebhookActionsMenuProps) {
  return (
    <Menu onOpenChange={onOpenChange}>
      <MenuTrigger
        render={<Button aria-label="Webhook actions" size="icon-xs" variant="ghost" />}
      >
        <Icon name="more-horizontal" size="md" />
      </MenuTrigger>
      <MenuPopup align="end">
        <MenuItem onClick={onEdit}>
          <Icon name="pen-line" size="md" />
          Edit
        </MenuItem>
        <MenuItem onClick={onToggleArchived}>
          <Icon name={archived ? "check-circle" : "x-circle"} size="md" />
          {archived ? "Enable webhook" : "Disable webhook"}
        </MenuItem>
        <MenuSeparator />
        <MenuItem onClick={onDelete} variant="destructive">
          <Icon name="trash-2" size="md" />
          Delete...
        </MenuItem>
      </MenuPopup>
    </Menu>
  );
}
